import { useCallback } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { autoEuropeDrawerData } from "Pages/AutoEuropeTool/Page/@signals"

export default function useAutoEuropeDataInfo(value) {
	const dataInfo = useSignal(value)

	const setDataInfo = useCallback((value, key) => batch(() => {
		dataInfo.value = value
		autoEuropeDrawerData.value = { ...autoEuropeDrawerData.value, [key]: value }
	}), [])

	return { dataInfo, setDataInfo }
}
